module.exports = "fragment BankAccountFragment on BankAccount {\n  __typename\n  id\n  bankName\n  object\n  last4\n  accountHolderName\n}\n"